// extracted by mini-css-extract-plugin
export default {"w-full":"Loader_w-full__LnetD","loader":"Loader_loader__IQiz-","loaderWhite":"Loader_loaderWhite__b4QqZ","loader-white":"Loader_loader-white__jqqz1"};